/* eslint-disable */
import anime from 'animejs';

export default {
  init() {
    // scripts here run on the DOM load event
    console.log('This is componentHistory');
  },
  finalize() {
    // scripts here fire after init() runs

    // var storyTransition = 200;
    // var i;
    // var storyReset = false;

    $('.story-show-more').on('click', function() {
      let currentStory = $(this).closest('.component.story');
      const currentID = $(currentStory).attr('id');

      let allStoryItems =  $(currentStory).find( '.story-item' );
      let hiddenElements = $(currentStory).find( '.story-item.hidden' );
      let iTheElementCount = $(currentStory).attr('data-element-count');

      const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

      var counter = 0;
      var iTheDelay = 100;

      if ($(currentStory).find( '.hidden' ).length) { // stuff will expand

        $(this).closest('.component.story').find('.story-grid-timeline').css('max-height', '');

        iTheDelay = 80;

        hiddenElements.each(function() {
          if (counter < iTheElementCount) {
            setTimeout(() => {
              $(this).removeClass('hidden -in').addClass('-out');
            }, iTheDelay * counter);
          }
          counter++;
        });

        setTimeout(() => {
          if (!$(currentStory).find( '.hidden' ).length) {
            $(this).children('span').text($(this).attr('data-close-label'));
            $(this).children('.icon').addClass('arrow-up');
          }
        }, iTheDelay * iTheElementCount);

      } else { // stuff will collapse

        iTheDelay = 100;
        $(this).children('.icon').removeClass('arrow-up');
        $(this).children('span').text($(this).attr('data-open-label'));

        var animateTo = $('#'+currentID);

        var iTheMaxHeight = 0;
        var iTheTotalDelay = (allStoryItems.length - iTheElementCount) * iTheDelay;

        for (var i = 0; i < iTheElementCount; i++) {
          iTheMaxHeight += $($(allStoryItems)[i]).outerHeight();
        }

        // set max-height to trigger container shrinking transition
        $(this).closest('.component.story').find('.story-grid-timeline').css('max-height', iTheMaxHeight / 10 + 'rem');

        // hide elements beginning from the last
        $(allStoryItems.get().reverse()).each(function(index) {
          if (allStoryItems.length - index > iTheElementCount) {
            setTimeout(() => {
              $(this).addClass('hidden');
            }, 200 + iTheTotalDelay );

            setTimeout(() => {
              $(this).removeClass('-in').addClass('-out');
            }, iTheDelay * index)
          }
        });

        // setTimeout(() => {
        //   $(this).closest('.component.story').find('.story-grid-timeline').css('max-height', '');
        // }, iTheTotalDelay + 400);

        // scroll to top of the recently collapsed component
        setTimeout(() => {
          anime({
            targets: scrollElement,
            scrollTop: animateTo.offset().top,
            duration: 600,
            easing: 'easeInOutQuart',
          });
        }, 200);

      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/components/story.js